import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-column justify-content-between lg:flex-row border-1 border-rounded border-200 mt-3 p-3 text-sm" }
const _hoisted_2 = { class: "text-justify" }
const _hoisted_3 = { class: "flex flex-column align-items-end pl-3" }
const _hoisted_4 = { class: "mb-2 pt-3 lg:pt-0" }
const _hoisted_5 = { class: "mr-1 text-sm" }

import { toRefs } from 'vue';
import ProgressBar from 'primevue/progressbar';
import { PastResultTreatmentGoalMeasurement } from '@/types';

interface Props {
  data: PastResultTreatmentGoalMeasurement;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'PastDocumentationGoal',
  props: {
    data: {}
  },
  setup(__props: any) {

const props = __props;

const { data } = toRefs(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(data).treatment_goal.description), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("b", _hoisted_5, _toDisplayString(_unref(data).percentage) + "%", 1),
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "dark-medium text-sm" }, "Completed", -1))
      ]),
      _createElementVNode("div", null, [
        _createVNode(_unref(ProgressBar), {
          value: _unref(data).percentage,
          "show-value": false
        }, null, 8, ["value"])
      ])
    ])
  ]))
}
}

})